document.addEventListener('alpine:init', () => {
  async function cartSection(response, section) {
    const bundled = response?.sections?.[section];
    if (typeof bundled === 'string' && bundled.trim()) return bundled;
    try {
      const url = new URL(theme.routes.cart_url, window.location.origin);
      url.searchParams.set('sections', section);
      const result = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
      if (!result.ok) throw new Error('Cart section refresh failed');
      const sections = await result.json();
      if (typeof sections[section] !== 'string' || !sections[section].trim()) throw new Error('Cart section unavailable');
      return sections[section];
    } catch (error) {
      const notice = document.getElementById('cart-errors');
      if (notice) notice.textContent = theme.strings.cartError;
      console.warn('Unable to refresh cart section:', section);
      return null;
    }
  }

  Alpine.store('cart_count', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    init() {
      window.addEventListener('switch:cart:afteradditem', (e) => {
        this._setFromFetchedSection(e.detail?.response);
      });

      window.addEventListener('switch:modalcart:cartqtychange', (e) => {
        this._setFromFetchedSection(e.detail?.response);
      });
    },
    _updateVersion: 0,
    async _setFromFetchedSection(data) {
      const version = ++this._updateVersion;
      const html = await cartSection(data, 'cart-item-count');
      if (!html || version !== this._updateVersion) return;
      const countNode = parseDOMFromString(html).firstElementChild;
      const count = Number.parseInt(countNode?.textContent.trim(), 10);
      if (Number.isFinite(count) && count >= 0) this.count = count;
    },
    countWithText() {
      let string = theme.strings.itemCountOther;

      if (this.count === 1) {
        string = theme.strings.itemCountOne;
      }

      return string.replace('{{ count }}', this.count);
    },
  });
});
